import { render, staticRenderFns } from "./CreatePurchase.vue?vue&type=template&id=881ca08e&scoped=true"
import script from "./CreatePurchase.vue?vue&type=script&lang=js"
export * from "./CreatePurchase.vue?vue&type=script&lang=js"
import style0 from "./CreatePurchase.vue?vue&type=style&index=0&id=881ca08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881ca08e",
  null
  
)

export default component.exports